//@ts-ignore: Unreachable code error
import Log from '@zjs/common/log';
import { CommonUtils, StringUtils } from '.';
const LOG_ERROR_URL = 'https://w-api.baomoi.com/api/v1/log/post';
const INTERNAL_LOG_URL = 'http://internal-api-lb-slave-clusterip-svc:8809/api/v1';

function tracking(url: string, params: object) {
    const _url = CommonUtils.buildURLWithParam(url, params);
    const img = document.createElement('img');

    img.setAttribute('src', _url);
    img.setAttribute('style', 'display:none');
}

export const Logger = {
    debug: (...params: any) => {
        Log.debug(params);
    },

    info: (...params: any) => {
        Log.info(params);
    },

    error: (errCode: number | string, ...params: any) => {
        if (typeof document !== 'undefined') {
            Log.error(StringUtils.stringify(params));
            tracking(
                `${LOG_ERROR_URL}?msg=${encodeURIComponent(
                    StringUtils.stringify(params)
                )}&code=${errCode}&type=${errCode}`,
                {}
            );
        } else {
            fetch(`${INTERNAL_LOG_URL}/log/post?msg=
            ${encodeURIComponent(
                StringUtils.stringify(params)
            )}&code=${errCode}&type=${errCode}`);
        }
    },

    errorWithType: (type: string, errCode: number | string, ...params: any) => {
        if (typeof document !== 'undefined') {
            Log.error(StringUtils.stringify(params));
            if (typeof document !== 'undefined') {
                tracking(
                    `${LOG_ERROR_URL}?msg=${encodeURIComponent(
                        StringUtils.stringify(params)
                    )}&code=${errCode}&type=${type}`,
                    {}
                );
            }
        }
        else {
            fetch(`${INTERNAL_LOG_URL}/log/post?msg=
            ${encodeURIComponent(
                StringUtils.stringify(params)
            )}&code=${errCode}&type=${type}`);
        }
    },

    errorImage: (...params: any) => {
        Log.error(StringUtils.stringify(params));
        if (typeof document !== 'undefined') {
            tracking(
                `${LOG_ERROR_URL}?msg=${encodeURIComponent(
                    StringUtils.stringify(params)
                )}&code=image&type=image`,
                {}
            );
        }
    },

    warn: (...params: any) => {
        Log.info(params);
    },
};